module.exports = __webpack_public_path__ + "img/publishDemand.fb58e89.png";